import styled from 'styled-components';
import { GridColDef, GridPagination, GridPaginationModel } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import { TTransactionSummary, TTransactionsFilters } from '../../Models/Transactions';
import { useContext, useEffect, useState } from 'react';
import { TransactionContext } from '../../contexts/TransactionContext';
import useService from '../../hooks/useService';
import { getPvcCenters, getTransactions, getTransactionsCount } from '../../services/Transactions';
import FiltersForm, { initialTransactionFilters } from './FiltersForm';
import { IconButton, Tooltip } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { DataFormat, PATHS } from '../../utils/constant';
import { TOption, TTransactionTypes } from '../../Models/common';
import moment from 'moment';
import { PageContext } from '../../contexts/PageContext';
import { ICustomerBasic } from '../../Models/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';

const Divider = styled.div`
    border: 1px solid #EBEBEC;
`

// Table Columns
const TRANSACTIONS_COLUMNS: GridColDef<TTransactionSummary>[] = [
    {
        field: "action",
        headerName: 'Action',
        hideSortIcons: true
    },
    {
        field: "globalTransactionNumber",
        headerName: 'GT Number',
        minWidth: 130,
    },
    {
        field: "transactionType",
        headerName: 'Type',
    },
    {
        field: "status",
        headerName: 'Status',
        minWidth: 180,
    },
    {
        field: "customerName",
        headerName: 'Customer Name',
        minWidth: 180,
        renderCell(params) {
            return params.row.customer.fullName
        },
    },
    {
        field: "customerRefNo",
        headerName: 'Customer Ref No',
        minWidth: 150,
        renderCell(params) {
            return params.row.customer.customerRefNo
        },
    },
    {
        field: "documentNumber",
        headerName: "Document Number",
        minWidth: 150,
        renderCell(params) {
            return params.row.documentNumber || "N/A"
        }
    },
    {
        field: "pvcCenter",
        headerName: 'Location',
        minWidth: 180,
        renderCell(params) {
            return params.row.pvcCenter.name
        },
    },
    {
        field: "secondaryTransactionLocation",
        headerName: 'Secondary Location',
        minWidth: 180,
        renderCell(params) {
            return params.row.secondaryTransactionLocation?.name || 'N/A'
        },
    },
    {
        field: "createdAt",
        headerName: 'Creation Date',
        minWidth: 200,
        renderCell(params) {
            const date = params.row.createdAt
            return date ? moment(date).format(DataFormat) : 'N/A'
        },
    },
    {
        field: "remarks",
        headerName: 'Remark',
        minWidth: 350,
        renderCell(params) {
            return params.row.remarks ? params.row.remarks : 'N/A'
        },
    }
]

const getViewUrl = (transactionType: TTransactionTypes, id: string) => {
    let path
    switch (transactionType) {
        case 'BUY_BACK':
            path = PATHS.BUY_BACK
            break;

        case 'BUY_SELL':
            path = PATHS.BUY_SELL
            break;

        case 'GMS':
            path = PATHS.GMS
            break;

        case 'JOB_WORK':
            path = PATHS.JOB_WORK
            break;

        case 'PURITY_TESTING':
            path = PATHS.PURITY_TESTING
            break;
        case 'MINTED_SALES':
            path = PATHS.MINTED_SALES
            break;
    }

    return path + '/' + id
}

export const PvcTransactions = () => {
    const navigate = useNavigate()
    const { transactions } = useContext(TransactionContext)
    const { setPageState } = useContext(PageContext)
    const { execute } = useService()
    const [count, setCount] = useState(0)
    const [filters, setFilters] = useState<TTransactionsFilters>(initialTransactionFilters)
    const { setCustomerConfig } = useContext(CustomerContext)
    
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    })

    const getColumns = () => {
        return TRANSACTIONS_COLUMNS.map<GridColDef<TTransactionSummary>>(column => {
            return column.field === 'action' ?
                {
                    ...column,
                    renderCell(params) {
                        return <Tooltip title='View Transaction'>
                            <IconButton onClick={() => {
                                setCustomerConfig({} as ICustomerBasic)
                                navigate(getViewUrl(params.row.transactionType as TTransactionTypes, params.row.globalTransactionNumber))
                            }}>
                                <Visibility />
                            </IconButton>
                        </Tooltip>
                    },
                } : column
        })
    }
    const submitHandler = (data: any): any => {
        console.log(data)
    }

    const getCount = async () => {
        const { data } = await execute(() => getTransactionsCount(filters))
        if (data) setCount(data.count)
    }

    const getLocation = () => {
        execute(() => getPvcCenters({}))
    }

    useEffect(() => {
        setPageState({
            title: 'PVC Transactions',
            currentPage: 'PVC Transactions',
            breadcrumbs: [],
            path: PATHS.PVC_TRANSACTIONS
        })
        getLocation()
    }, [])

    useEffect(() => {
        getCount()
    }, [filters])

    useEffect(() => {
        execute(() => getTransactions({ ...filters, pageNumber: paginationModel.page, pageSize: paginationModel.pageSize }))
    }, [paginationModel, filters])

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Global Transaction Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <FiltersForm setFilters={(params) => setFilters(params)} />
                <div></div>
            </div>
            <div style={{ overflow: 'hidden' }}>
                <Table
                    // slots={{
                    //     pagination: () => <GridPagination
                    //         page={paginationModel.page}
                    //         count={4}
                    //         rowsPerPage={2}
                    //         onPageChange={(_, page) => setPaginationModel(prev => ({ ...prev, page }))}
                    //     />
                    // }}
                    paginationModel={paginationModel}
                    onPaginationModelChange={(model) => setPaginationModel(model)}
                    pageSizeOptions={[10, 50, 100]}
                    columns={getColumns()}
                    rows={transactions}
                    getRowId={(row) => row.globalTransactionNumber}
                    hideFooter={false}
                    rowCount={count}
                    paginationMode='server'
                    disableColumnFilter
                />
            </div>
        </div>
    )
}
